// extracted by mini-css-extract-plugin
module.exports = {"select":"CustomSelect_select__LN1YF","error-message":"CustomSelect_error-message__oVSa2"};